import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { company, whatsappUrl } from "../data/site";

// Persistent mobile contact bar. Safe-area aware, non-intrusive.
export default function MobileContactBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-dark-gray bg-anthracite xl:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-contact-bar"
    >
      <div className="grid grid-cols-3">
        <a
          href={company.phoneLink}
          className="flex min-h-[60px] flex-col items-center justify-center gap-1 border-r border-dark-gray py-2 text-white transition-colors active:bg-dark-gray"
          data-testid="mobilebar-call"
        >
          <Phone className="h-5 w-5 text-yellow" />
          <span className="text-xs font-semibold">Anrufen</span>
        </a>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex min-h-[60px] flex-col items-center justify-center gap-1 border-r border-dark-gray py-2 text-white transition-colors active:bg-dark-gray"
          data-testid="mobilebar-whatsapp"
        >
          <MessageCircle className="h-5 w-5 text-yellow" />
          <span className="text-xs font-semibold">WhatsApp</span>
        </a>
        <Link
          to="/kontakt"
          className="flex min-h-[60px] flex-col items-center justify-center gap-1 bg-yellow py-2 text-brand-black transition-colors active:bg-yellow-dark"
          data-testid="mobilebar-inquiry"
        >
          <FileText className="h-5 w-5" />
          <span className="text-xs font-bold">Anfrage</span>
        </Link>
      </div>
    </div>
  );
}
